import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { Field } from 'redux-form';
import {
  isEmail, maxChar255, isRequired, dateRangeValidate,
} from '../../utils/validator';
import DatePicker from '../../lib/ui/form_elements/DatePicker';
import { colors } from '../../theme/style-helpers';
import RenderField from '../ReactComponent/RenderField';
import PrimaryButton from '../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../lib/ui/buttons/SecondaryButton';
import {
  ButtonGroup,
  CategoryTitle,
  ErrorIcon,
  ModalTitle,
  ButtonDiv,
  DownloadModalBody,
  ModalContainer,
  ModalTitlesContainer,
  ModalSubTitle,
  DatesContainer,
  CategoriesContainer,
  CategoryContainer,
  BoxContainer,
  BoxInfo,
} from './css';
import { FORM_FIELDS, SHIPMENT_REPORT_DATE_RANGE } from './utils';
import Checkbox from '../../lib/ui/form_elements/Checkbox';

const BOX_CONTAINER_MAX_HEIGHT = '145px';

const ModalContent = ({
  // eslint-disable-next-line no-unused-vars
  modalAction, modalShipmentNumber, closeModal, postShare, valid, accountNumbers, handleDownloadSubmit,
}) => {
  const newAccountNumbers = [];

  accountNumbers.map((item) => {
    newAccountNumbers.push({ label: item, value: item });
    return null;
  });

  return (modalAction === 'share'
    ? (
      <>
        <ModalTitle>{t('Share')}</ModalTitle>
        {t('ShareByEmailModal')}
        <Field
          name="shareShipmentEmail"
          type="email"
          component={RenderField}
          className="col"
          label={t('Email')}
          required
          validate={[isEmail, maxChar255, isRequired]}
        />
        <Field
          name="shareShipmentBody"
          type="textarea"
          component={RenderField}
          className="col"
          label={t('EmailBody')}
          validate={[maxChar255]}
        />
        <ButtonDiv>
          <PrimaryButton onClick={postShare} className={`${valid && 'active'} min-width`}>
            {t('ok')}
          </PrimaryButton>
        </ButtonDiv>
      </>
    )
    : modalAction === 'download'
      ? (
        <ModalContainer>
          <ModalTitlesContainer>
            <ModalTitle>{t('DownloadShipmentReportTitle')}</ModalTitle>
            <ModalSubTitle>{t('DownloadShipmentReportDescription')}</ModalSubTitle>
          </ModalTitlesContainer>

          <DownloadModalBody>
            <DatesContainer>
              <Field
                name="filterFromDate"
                component={DatePicker}
                initialDate={SHIPMENT_REPORT_DATE_RANGE.MIN}
                maxDate={SHIPMENT_REPORT_DATE_RANGE.MAX}
                label={t('FromDate')}
                validate={[isRequired, dateRangeValidate]}
              />
              <Field
                name="filterToDate"
                component={DatePicker}
                label={t('ToDate')}
                initialDate={SHIPMENT_REPORT_DATE_RANGE.MIN}
                maxDate={SHIPMENT_REPORT_DATE_RANGE.MAX}
                validate={[isRequired, dateRangeValidate]}
              />
            </DatesContainer>

            <CategoriesContainer>
              <CategoryContainer>
                <CategoryTitle>{t('BillingAccount')}</CategoryTitle>
                <BoxContainer
                  bgColor={colors.LIGHT_GREY}
                  maxHeight={BOX_CONTAINER_MAX_HEIGHT}
                >
                  <BoxInfo>
                    <Field
                      name={FORM_FIELDS.FILTER_ACCT_NUMBERS}
                      component={Checkbox}
                      options={newAccountNumbers}
                      multiple
                    />
                  </BoxInfo>
                </BoxContainer>
              </CategoryContainer>
            </CategoriesContainer>
          </DownloadModalBody>

          <ButtonGroup>
            <SecondaryButton
              label={t('Cancel')}
              onClick={closeModal}
              showArrow={false}
            />
            <PrimaryButton
              type="submit"
              label={t('Download')}
              onClick={handleDownloadSubmit}
            />
          </ButtonGroup>
        </ModalContainer>
      )
      : (
        <>
          <ErrorIcon src={Error} alt="Error" />
          <ModalTitle>{t('ErrorWithShippingAction')}</ModalTitle>
          <p>{t('PleaseContactSupportHotline')}</p>
          <ButtonDiv>
            <PrimaryButton onClick={closeModal} className="active min-width">
              {t('ok')}
            </PrimaryButton>
          </ButtonDiv>
        </>
      )
  );
};

ModalContent.propTypes = {
  modalAction: PropTypes.oneOf(['share', 'download', 'error']),
  modalShipmentNumber: PropTypes.string,
  closeModal: PropTypes.func,
  postShare: PropTypes.func,
  valid: PropTypes.bool,
  accountNumbers: PropTypes.arrayOf(PropTypes.string),
  handleDownloadSubmit: PropTypes.func,
};

export default ModalContent;
